// Sales by Buyer & Country (66_SalesByBuyer.jsx — task #96, Anh Le's workbook as a screen, 31/10/2026).
const en = {
  fcEdit: 'Edit FC',
  fcHint: 'The {{y}} forecast by month, in USD — leave a month empty to clear it.',
  fcBad: 'A forecast is an amount in USD.',
  fcBy: '{{y}} forecast last saved by {{by}}, {{at}}.',
  yoyCompare: 'Year Over Year Comparison',
  yoyComparison: 'YOY Comparison (growth by month)',
  matrixTitle: 'Ex-factory sales by year and month (USD)',
  matrixNote: "Growth = the year's total as a share of the year before's (as in Sales Report by Year). The bottom row: {{b}} as a share of {{a}}, month by month; its total runs Jan – {{to}}.",
  maxLossCard: 'Maximum YoY fall',
  maxGainCard: 'Maximum YoY gain',
  growthByMonth: 'Growth by month, {{b}} on {{a}}',
  salesLegend: 'Sales',
  growthAmount: 'Growth (amount)',
  growthRate: 'Growth rate',
  unitShare: '% units',
  saleAmount: 'Sale amount',
  dbByYear: 'Sale amount & units sold by year',
  dbUnitsCategory: 'Units sold by product category',
  dbUnitsModel: 'Units sold by model (top 15)',
  dbUnitsBuyer: 'Units sold by buyer (top 15)',
  dbUnitsCountry: 'Units sold by country (top 15) · key model',
  dbShareCountry: 'Share of units by country',
  top15Total: 'Top 15 total',
  keyModel: 'Key model (% of country)',
  others: 'Others',
  tabDash: 'Dashboard',
  filters: 'Filters',
  allMonths: 'All months',
  all: 'All',
  category: 'Category',
  product: 'Product',
  kSales: 'Total sales (USD)',
  kLines: '{{n}} order lines',
  kUnits: 'Units sold',
  kAvgUnit: 'avg {{v}} / unit',
  kBuyers: 'Buyers',
  kOfYear: 'of {{n}} this year',
  kCountries: 'Countries served',
  kAvgBuyer: 'Avg sales / buyer',
  kProducts: '{{n}} products sold',
  kYoy: 'Growth on last year',
  kVsMonth: 'vs {{m}} {{y}}: {{v}}',
  kVsYtd: 'vs Jan – {{m}} {{y}}: {{v}}',
  dbByMonth: 'Sale amount by month, {{y}} (USD)',
  avgUnit: 'Avg / unit',
  ofYear: '% of year',
  dbTopBuyers: 'Top buyers (USD)',
  dbTopProducts: 'Top products by units',
  dbByCategory: 'By category',
  dbByCountry: 'By country',
  share: 'Share',
  dbSrcFile: "Line by line from Mia's Data sheet (up to Sep 2026).",
  dbSrcSap: 'Line by line from SAP billing (free-of-charge items left out).',
  dbSrcBoth: "Line by line: Mia's Data sheet up to Sep 2026, SAP billing after (free-of-charge items left out).",
  tabBuyer: 'By buyer & country',
  tabYoy: 'Year over year',
  soFar: '{{m}} is still running — the days so far. The like-for-like total stops at the month before.',
  yearA: 'Compare',
  yearB: 'with',
  ytdTitle: 'Jan – {{to}} (like for like)',
  vsYear: 'vs {{y}}: {{v}}',
  fullYear: 'Year {{y}}',
  toMonth: 'to {{m}}',
  wholeYear: 'whole year',
  byMonthTitle: '{{a}} vs {{b}} by month (USD)',
  month: 'Month',
  diff: 'Difference',
  growth: 'Growth',
  ytdShort: 'Jan – {{to}}',
  yearWise: 'Year-wise sales (USD)',
  maxGain: 'Biggest gain',
  maxLoss: 'Biggest fall',
  partialNote: 'A year still running is compared with the whole year before it in this table; the like-for-like figure is the one above. Biggest gain / fall: full years only.',
  nav: 'Overseas Sales',
  title: 'Overseas Sales',
  sub: 'HINC overseas billing (sales org 1100) in USD, by buyer and month — Sales Team 1\'s "Sales amount per Year per country".',
  year: 'Year',
  groupBy: 'Group by',
  buyer: 'Buyer',
  country: 'Country',
  search: 'Search',
  searchPh: 'Buyer, country, region',
  hideEmpty: 'Hide buyers with no sales',
  excel: 'Excel',
  monthToRead: 'Month to read from SAP',
  readSap: 'Read from SAP',
  reading: 'Reading SAP…',
  confirmReplace: '{{m}} holds the workbook\'s numbers. Read it from SAP instead? From then on that month shows SAP\'s billing.',
  loaded: '{{m}} read from SAP: {{n}} billing document(s), USD {{usd}}.',
  legend: 'Months marked SAP come from SAP billing (click a number to see its documents); the others are the workbook\'s own numbers. Read by itself on the 6th for the month before.',
  fromSapAt: 'From SAP — read {{at}} by {{by}}, {{n}} document(s)',
  fromFile: 'From the workbook',
  total: 'Total',
  nBuyers: '{{n}} buyer(s)',
  noRows: 'Nothing to show.',
  loading: 'Loading…',
  notMapped: '{{n}} SAP customer(s) not in the report yet',
  notMappedSub: 'Billed in a month read from SAP but on no row of the report. Put each on a buyer, add a buyer, or leave it out — their amounts are not in the totals above until then.',
  sapCustomer: 'SAP customer',
  putOn: 'Put on',
  pick: 'Choose…',
  newBuyer: '+ New buyer',
  exclude: 'Leave out of the report',
  save: 'Save',
  askEditor: 'Someone with edit rights places it.',
  billing: 'Billing doc.',
  date: 'Date',
  channel: 'Channel',
  amountDoc: 'Amount',
  rate: 'USD rate',
  close: 'Close',
  cancel: 'Cancel',
  fModel: 'Model',
  fColor: 'Colour',
  dbModelGrid: 'Units sold by country and year — {{m}}',
  dbModelGridSub: 'Every year of the sales lines, under the filters above (the Year filter is for the sections below). Hover a number for its sales amount.',
  dbModelGridMonth: 'Every year\'s {{m}} only (the Month filter), under the filters above. Hover a number for its sales amount.',
  dbModelGridNone: 'No units sold for this pick.',
};

const ko = {
  fcEdit: 'FC 수정',
  fcHint: '{{y}}년 월별 예측 (USD) — 비우면 그 달은 지워져요.',
  fcBad: '예측은 USD 금액이어야 해요.',
  fcBy: '{{y}}년 예측 마지막 저장: {{by}}, {{at}}.',
  yoyCompare: '전년 대비 비교',
  yoyComparison: 'YOY 비교 (월별 증감률)',
  matrixTitle: '연도·월별 출고 매출 (USD)',
  matrixNote: 'Growth = 전년 합계 대비 올해 합계 비율 (Sales Report by Year와 같은 방식). 마지막 행: {{a}} 대비 {{b}} 월별 비율, 합계는 1월 – {{to}}.',
  maxLossCard: '최대 감소율',
  maxGainCard: '최대 증가율',
  growthByMonth: '월별 증감률, {{a}} 대비 {{b}}',
  salesLegend: '매출',
  growthAmount: '증감액',
  growthRate: '증감률',
  unitShare: '수량 %',
  saleAmount: '매출액',
  dbByYear: '연도별 매출액·판매 수량',
  dbUnitsCategory: '제품 카테고리별 판매 수량',
  dbUnitsModel: '모델별 판매 수량 (상위 15)',
  dbUnitsBuyer: '바이어별 판매 수량 (상위 15)',
  dbUnitsCountry: '국가별 판매 수량 (상위 15) · 주력 모델',
  dbShareCountry: '국가별 수량 비중',
  top15Total: '상위 15 합계',
  keyModel: '주력 모델 (국가 내 %)',
  others: '기타',
  tabDash: '대시보드',
  filters: '필터',
  allMonths: '전체 월',
  all: '전체',
  category: '카테고리',
  product: '제품',
  kSales: '총 매출 (USD)',
  kLines: '주문 행 {{n}}개',
  kUnits: '판매 수량',
  kAvgUnit: '개당 평균 {{v}}',
  kBuyers: '바이어',
  kOfYear: '올해 {{n}}곳 중',
  kCountries: '판매 국가',
  kAvgBuyer: '바이어당 평균 매출',
  kProducts: '판매 제품 {{n}}종',
  kYoy: '전년 대비',
  kVsMonth: '{{y}}년 {{m}}: {{v}}',
  kVsYtd: '{{y}}년 1월 – {{m}}: {{v}}',
  dbByMonth: '월별 매출액, {{y}}년 (USD)',
  avgUnit: '개당 평균',
  ofYear: '연간 비중',
  dbTopBuyers: '상위 바이어 (USD)',
  dbTopProducts: '수량 기준 상위 제품',
  dbByCategory: '카테고리별',
  dbByCountry: '국가별',
  share: '비중',
  dbSrcFile: 'Mia의 Data 시트 행 기준 (2026년 9월까지).',
  dbSrcSap: 'SAP 청구 행 기준 (무상 품목 제외).',
  dbSrcBoth: '행 기준: 2026년 9월까지 Mia의 Data 시트, 이후 SAP 청구 (무상 품목 제외).',
  tabBuyer: '바이어·국가별',
  tabYoy: '전년 대비',
  soFar: '{{m}}은 아직 진행 중이라 오늘까지의 숫자예요. 동기간 합계는 그 전 달까지예요.',
  yearA: '비교',
  yearB: '대상',
  ytdTitle: '1월 – {{to}} (동기간)',
  vsYear: '{{y}}년: {{v}}',
  fullYear: '{{y}}년',
  toMonth: '{{m}}까지',
  wholeYear: '연간',
  byMonthTitle: '{{a}} vs {{b}} 월별 (USD)',
  month: '월',
  diff: '차이',
  growth: '증감률',
  ytdShort: '1월 – {{to}}',
  yearWise: '연도별 매출 (USD)',
  maxGain: '최대 증가',
  maxLoss: '최대 감소',
  partialNote: '진행 중인 연도는 이 표에서 전년 전체와 비교돼요. 동기간 비교는 위 숫자를 보세요. 최대 증가/감소는 완료된 연도만 봐요.',
  nav: '해외 매출',
  title: '해외 매출',
  sub: 'HINC 해외 매출(판매조직 1100), USD, 바이어·월별 — Sales Team 1의 "Sales amount per Year per country".',
  year: '연도',
  groupBy: '묶음',
  buyer: '바이어',
  country: '국가',
  search: '검색',
  searchPh: '바이어, 국가, 지역',
  hideEmpty: '매출 없는 바이어 숨기기',
  excel: 'Excel',
  monthToRead: 'SAP에서 읽을 월',
  readSap: 'SAP에서 읽기',
  reading: 'SAP 읽는 중…',
  confirmReplace: '{{m}}에는 엑셀 파일의 숫자가 들어 있어요. SAP에서 다시 읽을까요? 이후 그 달은 SAP 청구 기준으로 보여요.',
  loaded: '{{m}} SAP에서 읽음: 청구 문서 {{n}}건, USD {{usd}}.',
  legend: 'SAP 표시가 있는 월은 SAP 청구 기준이에요(숫자를 누르면 문서가 보여요). 나머지는 엑셀 파일의 숫자예요. 매월 6일에 지난달을 자동으로 읽어요.',
  fromSapAt: 'SAP 기준 — {{at}} {{by}} 읽음, 문서 {{n}}건',
  fromFile: '엑셀 파일 기준',
  total: '합계',
  nBuyers: '바이어 {{n}}곳',
  noRows: '표시할 내용이 없어요.',
  loading: '불러오는 중…',
  notMapped: '보고서에 아직 없는 SAP 고객 {{n}}곳',
  notMappedSub: 'SAP에서 읽은 달에 청구됐지만 어느 행에도 없어요. 바이어에 넣거나, 새 바이어를 만들거나, 제외하세요 — 그 전까지 위 합계에 들어가지 않아요.',
  sapCustomer: 'SAP 고객',
  putOn: '넣을 곳',
  pick: '선택…',
  newBuyer: '+ 새 바이어',
  exclude: '보고서에서 제외',
  save: '저장',
  askEditor: '편집 권한이 있는 분이 배정해요.',
  billing: '청구 문서',
  date: '날짜',
  channel: '유통경로',
  amountDoc: '금액',
  rate: 'USD 환율',
  close: '닫기',
  cancel: '취소',
  fModel: '모델',
  fColor: '색상',
  dbModelGrid: '국가·연도별 판매 수량 — {{m}}',
  dbModelGridSub: '매출 라인의 모든 연도, 위 필터 적용 (연도 필터는 아래 섹션용). 숫자에 마우스를 올리면 매출액이 보입니다.',
  dbModelGridMonth: '각 연도의 {{m}}만 (월 필터), 위 필터 적용. 숫자에 마우스를 올리면 매출액이 보입니다.',
  dbModelGridNone: '이 조건으로 판매된 수량이 없습니다.',
};

const vi = {
  fcEdit: 'Sửa FC',
  fcHint: 'Forecast năm {{y}} theo tháng, bằng USD — để trống tháng nào là xóa tháng đó.',
  fcBad: 'Forecast phải là số tiền USD.',
  fcBy: 'Forecast {{y}} lưu lần cuối bởi {{by}}, {{at}}.',
  yoyCompare: 'So sánh cùng kỳ năm trước',
  yoyComparison: 'So sánh YOY (tăng trưởng theo tháng)',
  matrixTitle: 'Doanh số Ex-factory theo năm và tháng (USD)',
  matrixNote: 'Growth = tổng năm chia tổng năm trước (như file Sales Report by Year). Dòng cuối: {{b}} so với {{a}} theo từng tháng; cột tổng tính Jan – {{to}}.',
  maxLossCard: 'Giảm mạnh nhất (YoY)',
  maxGainCard: 'Tăng mạnh nhất (YoY)',
  growthByMonth: 'Tăng trưởng theo tháng, {{b}} so với {{a}}',
  salesLegend: 'Doanh số',
  growthAmount: 'Tăng trưởng (số tiền)',
  growthRate: 'Tốc độ tăng trưởng',
  unitShare: '% số lượng',
  saleAmount: 'Doanh số',
  dbByYear: 'Doanh số & số lượng theo năm',
  dbUnitsCategory: 'Số lượng theo category',
  dbUnitsModel: 'Số lượng theo model (top 15)',
  dbUnitsBuyer: 'Số lượng theo buyer (top 15)',
  dbUnitsCountry: 'Số lượng theo nước (top 15) · model chủ lực',
  dbShareCountry: 'Tỷ trọng số lượng theo nước',
  top15Total: 'Tổng top 15',
  keyModel: 'Model chủ lực (% của nước)',
  others: 'Khác',
  tabDash: 'Dashboard',
  filters: 'Bộ lọc',
  allMonths: 'Tất cả tháng',
  all: 'Tất cả',
  category: 'Category',
  product: 'Sản phẩm',
  kSales: 'Tổng doanh số (USD)',
  kLines: '{{n}} dòng đơn',
  kUnits: 'Số đơn vị bán',
  kAvgUnit: 'trung bình {{v}} / cái',
  kBuyers: 'Buyer',
  kOfYear: 'trên {{n}} của năm',
  kCountries: 'Số nước',
  kAvgBuyer: 'Doanh số TB / buyer',
  kProducts: '{{n}} sản phẩm đã bán',
  kYoy: 'Tăng trưởng so với năm trước',
  kVsMonth: 'so với {{m}} {{y}}: {{v}}',
  kVsYtd: 'so với Jan – {{m}} {{y}}: {{v}}',
  dbByMonth: 'Doanh số theo tháng, năm {{y}} (USD)',
  avgUnit: 'TB / cái',
  ofYear: '% của năm',
  dbTopBuyers: 'Top buyer (USD)',
  dbTopProducts: 'Top sản phẩm theo số lượng',
  dbByCategory: 'Theo category',
  dbByCountry: 'Theo nước',
  share: 'Tỷ trọng',
  dbSrcFile: 'Từng dòng từ sheet Data của Mia (tới 09/2026).',
  dbSrcSap: 'Từng dòng từ hóa đơn SAP (bỏ dòng tặng miễn phí).',
  dbSrcBoth: 'Từng dòng: sheet Data của Mia tới 09/2026, sau đó là hóa đơn SAP (bỏ dòng tặng miễn phí).',
  tabBuyer: 'Theo buyer & nước',
  tabYoy: 'So sánh năm',
  soFar: '{{m}} chưa hết tháng — số tính tới hôm nay. Số so cùng kỳ chỉ tính tới tháng trước đó.',
  yearA: 'So sánh',
  yearB: 'với',
  ytdTitle: 'Jan – {{to}} (cùng kỳ)',
  vsYear: 'so với {{y}}: {{v}}',
  fullYear: 'Năm {{y}}',
  toMonth: 'tới {{m}}',
  wholeYear: 'cả năm',
  byMonthTitle: '{{a}} so với {{b}} theo tháng (USD)',
  month: 'Tháng',
  diff: 'Chênh lệch',
  growth: 'Tăng trưởng',
  ytdShort: 'Jan – {{to}}',
  yearWise: 'Doanh số theo năm (USD)',
  maxGain: 'Tăng mạnh nhất',
  maxLoss: 'Giảm mạnh nhất',
  partialNote: 'Năm chưa hết thì trong bảng này đang so với cả năm trước; số so cùng kỳ là số ở phía trên. Tăng/giảm mạnh nhất chỉ tính các năm đã trọn.',
  nav: 'Overseas Sales',
  title: 'Overseas Sales',
  sub: 'Doanh số xuất khẩu của HINC (sales org 1100) bằng USD, theo buyer và tháng — file "Sales amount per Year per country" của Sales Team 1.',
  year: 'Năm',
  groupBy: 'Gộp theo',
  buyer: 'Buyer',
  country: 'Nước',
  search: 'Tìm',
  searchPh: 'Buyer, nước, region',
  hideEmpty: 'Ẩn buyer không có doanh số',
  excel: 'Excel',
  monthToRead: 'Tháng cần đọc từ SAP',
  readSap: 'Đọc từ SAP',
  reading: 'Đang đọc SAP…',
  confirmReplace: '{{m}} đang là số trong file Excel. Đọc lại từ SAP không? Từ đó tháng này sẽ hiện theo hóa đơn SAP.',
  loaded: 'Đã đọc {{m}} từ SAP: {{n}} hóa đơn, USD {{usd}}.',
  legend: 'Tháng có nhãn SAP lấy từ hóa đơn SAP (bấm vào số để xem từng hóa đơn); các tháng khác là số trong file Excel. Ngày 6 hằng tháng hệ thống tự đọc tháng trước.',
  fromSapAt: 'Từ SAP — đọc lúc {{at}} bởi {{by}}, {{n}} hóa đơn',
  fromFile: 'Từ file Excel',
  total: 'Tổng',
  nBuyers: '{{n}} buyer',
  noRows: 'Không có gì để hiện.',
  loading: 'Đang tải…',
  notMapped: '{{n}} khách SAP chưa có trong báo cáo',
  notMappedSub: 'Có hóa đơn trong tháng đọc từ SAP nhưng chưa thuộc dòng nào. Gắn vào buyer có sẵn, thêm buyer mới, hoặc bỏ ra khỏi báo cáo — chưa gắn thì số tiền chưa vào tổng ở trên.',
  sapCustomer: 'Khách SAP',
  putOn: 'Gắn vào',
  pick: 'Chọn…',
  newBuyer: '+ Buyer mới',
  exclude: 'Bỏ khỏi báo cáo',
  save: 'Lưu',
  askEditor: 'Người có quyền sửa sẽ gắn.',
  billing: 'Số hóa đơn',
  date: 'Ngày',
  channel: 'Kênh',
  amountDoc: 'Số tiền',
  rate: 'Tỷ giá USD',
  close: 'Đóng',
  cancel: 'Hủy',
  fModel: 'Model',
  fColor: 'Màu',
  dbModelGrid: 'Số lượng bán theo nước và năm — {{m}}',
  dbModelGridSub: 'Mọi năm của dữ liệu bán, theo các bộ lọc phía trên (bộ lọc Năm dành cho các phần bên dưới). Rê chuột vào số để xem doanh số.',
  dbModelGridMonth: 'Chỉ tháng {{m}} của mỗi năm (bộ lọc Tháng), theo các bộ lọc phía trên. Rê chuột vào số để xem doanh số.',
  dbModelGridNone: 'Không có số lượng bán nào cho lựa chọn này.',
};

const zh = {
  fcEdit: '编辑 FC',
  fcHint: '{{y}} 年按月预测（USD）— 留空即清除该月。',
  fcBad: '预测须为美元金额。',
  fcBy: '{{y}} 年预测最后由 {{by}} 保存，{{at}}。',
  yoyCompare: '同比比较',
  yoyComparison: 'YOY 比较（按月增长率）',
  matrixTitle: '按年和月的出厂销售额（USD）',
  matrixNote: 'Growth = 当年合计占上一年合计的比例（与 Sales Report by Year 相同）。最后一行：{{b}} 占 {{a}} 的逐月比例；合计为 1月 – {{to}}。',
  maxLossCard: '最大同比下降',
  maxGainCard: '最大同比增长',
  growthByMonth: '按月增长率，{{b}} 对比 {{a}}',
  salesLegend: '销售额',
  growthAmount: '增长额',
  growthRate: '增长率',
  unitShare: '数量 %',
  saleAmount: '销售额',
  dbByYear: '按年销售额与数量',
  dbUnitsCategory: '按产品类别的销售数量',
  dbUnitsModel: '按型号的销售数量（前 15）',
  dbUnitsBuyer: '按买家的销售数量（前 15）',
  dbUnitsCountry: '按国家的销售数量（前 15）· 主力型号',
  dbShareCountry: '按国家的数量占比',
  top15Total: '前 15 合计',
  keyModel: '主力型号（占该国 %）',
  others: '其他',
  tabDash: '仪表板',
  filters: '筛选',
  allMonths: '全部月份',
  all: '全部',
  category: '类别',
  product: '产品',
  kSales: '总销售额 (USD)',
  kLines: '{{n}} 条订单行',
  kUnits: '销售数量',
  kAvgUnit: '平均 {{v}} / 件',
  kBuyers: '买家',
  kOfYear: '本年共 {{n}}',
  kCountries: '覆盖国家',
  kAvgBuyer: '每买家平均销售额',
  kProducts: '已售 {{n}} 种产品',
  kYoy: '同比增长',
  kVsMonth: '对比 {{y}} 年 {{m}}：{{v}}',
  kVsYtd: '对比 {{y}} 年 1月 – {{m}}：{{v}}',
  dbByMonth: '按月销售额，{{y}} 年（USD）',
  avgUnit: '平均单价',
  ofYear: '占全年 %',
  dbTopBuyers: '主要买家 (USD)',
  dbTopProducts: '按数量排名的产品',
  dbByCategory: '按类别',
  dbByCountry: '按国家',
  share: '占比',
  dbSrcFile: '逐行取自 Mia 的 Data 工作表（至 2026 年 9 月）。',
  dbSrcSap: '逐行取自 SAP 开票（不含免费品项）。',
  dbSrcBoth: '逐行：2026 年 9 月及以前取自 Mia 的 Data 工作表，之后取自 SAP 开票（不含免费品项）。',
  tabBuyer: '按买家与国家',
  tabYoy: '同比',
  soFar: '{{m}} 尚未结束 — 为截至今天的数字。同期合计只到上个月。',
  yearA: '比较',
  yearB: '与',
  ytdTitle: '1月 – {{to}}（同期）',
  vsYear: '对比 {{y}}：{{v}}',
  fullYear: '{{y}} 年',
  toMonth: '至 {{m}}',
  wholeYear: '全年',
  byMonthTitle: '{{a}} 与 {{b}} 按月（USD）',
  month: '月份',
  diff: '差额',
  growth: '增长率',
  ytdShort: '1月 – {{to}}',
  yearWise: '按年销售额（USD）',
  maxGain: '最大增长',
  maxLoss: '最大下降',
  partialNote: '本表中进行中的年份与上一年全年比较；同期比较请看上方数字。最大增长/下降仅计算完整年份。',
  nav: '海外销售',
  title: '海外销售',
  sub: 'HINC 海外开票（销售组织 1100），美元，按买家和月份 — Sales Team 1 的 "Sales amount per Year per country"。',
  year: '年份',
  groupBy: '分组',
  buyer: '买家',
  country: '国家',
  search: '搜索',
  searchPh: '买家、国家、区域',
  hideEmpty: '隐藏无销售的买家',
  excel: 'Excel',
  monthToRead: '从 SAP 读取的月份',
  readSap: '从 SAP 读取',
  reading: '正在读取 SAP…',
  confirmReplace: '{{m}} 目前是 Excel 文件中的数字。改为从 SAP 读取吗？此后该月按 SAP 开票显示。',
  loaded: '已从 SAP 读取 {{m}}：{{n}} 张开票凭证，USD {{usd}}。',
  legend: '标有 SAP 的月份来自 SAP 开票（点击数字查看凭证）；其他月份为 Excel 文件中的数字。每月 6 日自动读取上月。',
  fromSapAt: '来自 SAP — {{at}} 由 {{by}} 读取，{{n}} 张凭证',
  fromFile: '来自 Excel 文件',
  total: '合计',
  nBuyers: '{{n}} 个买家',
  noRows: '没有可显示的内容。',
  loading: '加载中…',
  notMapped: '{{n}} 个 SAP 客户尚未纳入报表',
  notMappedSub: '在从 SAP 读取的月份中有开票，但不属于任何一行。请归入已有买家、新增买家或排除 — 在此之前其金额不计入上方合计。',
  sapCustomer: 'SAP 客户',
  putOn: '归入',
  pick: '选择…',
  newBuyer: '+ 新买家',
  exclude: '不计入报表',
  save: '保存',
  askEditor: '由有编辑权限的人归入。',
  billing: '开票凭证',
  date: '日期',
  channel: '分销渠道',
  amountDoc: '金额',
  rate: 'USD 汇率',
  close: '关闭',
  cancel: '取消',
  fModel: '型号',
  fColor: '颜色',
  dbModelGrid: '按国家和年份的销售数量 — {{m}}',
  dbModelGridSub: '销售明细的所有年份，按上方筛选（年份筛选用于下方各部分）。鼠标悬停数字可查看销售额。',
  dbModelGridMonth: '仅每年的 {{m}}（月份筛选），按上方筛选。鼠标悬停数字可查看销售额。',
  dbModelGridNone: '此选择没有销售数量。',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "fcEdit": "Modifier le FC",
  "fcHint": "Prévision {{y}} par mois, en USD — laissez un mois vide pour l'effacer.",
  "fcBad": "Une prévision est un montant en USD.",
  "fcBy": "Prévision {{y}} enregistrée en dernier par {{by}}, {{at}}.",
  "yoyCompare": "Comparaison d'une année sur l'autre",
  "yoyComparison": "Comparaison YoY (croissance par mois)",
  "matrixTitle": "Ventes départ usine par année et par mois (USD)",
  "matrixNote": "Croissance = total de l'année en pourcentage de celui de l'année précédente (comme dans Sales Report by Year). Dernière ligne : {{b}} en pourcentage de {{a}}, mois par mois ; son total court de janv. à {{to}}.",
  "maxLossCard": "Baisse YoY maximale",
  "maxGainCard": "Hausse YoY maximale",
  "growthByMonth": "Croissance par mois, {{b}} par rapport à {{a}}",
  "salesLegend": "Ventes",
  "growthAmount": "Croissance (montant)",
  "growthRate": "Taux de croissance",
  "unitShare": "% unités",
  "saleAmount": "Montant des ventes",
  "dbByYear": "Montant des ventes et unités vendues par année",
  "dbUnitsCategory": "Unités vendues par catégorie de produits",
  "dbUnitsModel": "Unités vendues par modèle (top 15)",
  "dbUnitsBuyer": "Unités vendues par acheteur (top 15)",
  "dbUnitsCountry": "Unités vendues par pays (top 15) · modèle clé",
  "dbShareCountry": "Part des unités par pays",
  "top15Total": "Total top 15",
  "keyModel": "Modèle clé (% du pays)",
  "others": "Autres",
  "tabDash": "Tableau de bord",
  "filters": "Filtres",
  "allMonths": "Tous les mois",
  "all": "Tout",
  "category": "Catégorie",
  "product": "Produit",
  "kSales": "Ventes totales (USD)",
  "kLines": "{{n}} lignes de commande",
  "kUnits": "Unités vendues",
  "kAvgUnit": "moy. {{v}} / unité",
  "kBuyers": "Acheteurs",
  "kOfYear": "sur {{n}} cette année",
  "kCountries": "Pays servis",
  "kAvgBuyer": "Ventes moy. / acheteur",
  "kProducts": "{{n}} produits vendus",
  "kYoy": "Croissance par rapport à l'an dernier",
  "kVsMonth": "vs {{m}} {{y}} : {{v}}",
  "kVsYtd": "vs janv. – {{m}} {{y}} : {{v}}",
  "dbByMonth": "Montant des ventes par mois, {{y}} (USD)",
  "avgUnit": "Moy. / unité",
  "ofYear": "% de l'année",
  "dbTopBuyers": "Top acheteurs (USD)",
  "dbTopProducts": "Top produits par unités",
  "dbByCategory": "Par catégorie",
  "dbByCountry": "Par pays",
  "share": "Part",
  "dbSrcFile": "Ligne par ligne depuis la feuille Data de Mia (jusqu'à sept. 2026).",
  "dbSrcSap": "Ligne par ligne depuis la facturation SAP (articles gratuits exclus).",
  "dbSrcBoth": "Ligne par ligne : feuille Data de Mia jusqu'à sept. 2026, facturation SAP ensuite (articles gratuits exclus).",
  "tabBuyer": "Par acheteur et pays",
  "tabYoy": "Année sur année",
  "soFar": "{{m}} est encore en cours — les jours écoulés. Le total à périmètre comparable s'arrête au mois précédent.",
  "yearA": "Comparer",
  "yearB": "avec",
  "ytdTitle": "Janv. – {{to}} (à périmètre comparable)",
  "vsYear": "vs {{y}} : {{v}}",
  "fullYear": "Année {{y}}",
  "toMonth": "jusqu'à {{m}}",
  "wholeYear": "année complète",
  "byMonthTitle": "{{a}} vs {{b}} par mois (USD)",
  "month": "Mois",
  "diff": "Différence",
  "growth": "Croissance",
  "ytdShort": "Janv. – {{to}}",
  "yearWise": "Ventes par année (USD)",
  "maxGain": "Plus forte hausse",
  "maxLoss": "Plus forte baisse",
  "partialNote": "Dans ce tableau, une année en cours est comparée à l'année précédente complète ; le chiffre à périmètre comparable est celui ci-dessus. Plus forte hausse / baisse : années complètes uniquement.",
  "nav": "Overseas Sales",
  "title": "Overseas Sales",
  "sub": "Facturation export HINC (organisation commerciale 1100) en USD, par acheteur et par mois — « Sales amount per Year per country » de Sales Team 1.",
  "year": "Année",
  "groupBy": "Regrouper par",
  "buyer": "Acheteur",
  "country": "Pays",
  "search": "Rechercher",
  "searchPh": "Acheteur, pays, région",
  "hideEmpty": "Masquer les acheteurs sans ventes",
  "excel": "Excel",
  "monthToRead": "Mois à lire depuis SAP",
  "readSap": "Lire depuis SAP",
  "reading": "Lecture de SAP…",
  "confirmReplace": "{{m}} contient les chiffres du classeur. Les lire plutôt depuis SAP ? Ensuite, ce mois affichera la facturation SAP.",
  "loaded": "{{m}} lu depuis SAP : {{n}} document(s) de facturation, USD {{usd}}.",
  "legend": "Les mois marqués SAP proviennent de la facturation SAP (cliquez sur un chiffre pour voir ses documents) ; les autres sont les chiffres propres du classeur. Lecture automatique le 6 pour le mois précédent.",
  "fromSapAt": "Depuis SAP — lu le {{at}} par {{by}}, {{n}} document(s)",
  "fromFile": "Depuis le classeur",
  "total": "Total",
  "nBuyers": "{{n}} acheteur(s)",
  "noRows": "Rien à afficher.",
  "loading": "Chargement…",
  "notMapped": "{{n}} client(s) SAP pas encore dans le rapport",
  "notMappedSub": "Facturés dans un mois lu depuis SAP mais absents de toutes les lignes du rapport. Rattachez chacun à un acheteur, ajoutez un acheteur ou excluez-le — leurs montants ne figurent pas dans les totaux ci-dessus d'ici là.",
  "sapCustomer": "Client SAP",
  "putOn": "Rattacher à",
  "pick": "Choisir…",
  "newBuyer": "+ Nouvel acheteur",
  "exclude": "Exclure du rapport",
  "save": "Enregistrer",
  "askEditor": "Une personne disposant des droits de modification le place.",
  "billing": "Doc. de facturation",
  "date": "Date",
  "channel": "Canal",
  "amountDoc": "Montant",
  "rate": "Taux USD",
  "close": "Fermer",
  "cancel": "Annuler",
  "fModel": "Modèle",
  "fColor": "Couleur",
  "dbModelGrid": "Unités vendues par pays et par année — {{m}}",
  "dbModelGridSub": "Toutes les années des lignes de vente, selon les filtres ci-dessus (le filtre Année concerne les sections ci-dessous). Survolez un chiffre pour voir son montant de ventes.",
  "dbModelGridMonth": "Uniquement le mois {{m}} de chaque année (filtre Mois), selon les filtres ci-dessus. Survolez un chiffre pour voir son montant de ventes.",
  "dbModelGridNone": "Aucune unité vendue pour cette sélection."
};
const ja = {
  "fcEdit": "FCを編集",
  "fcHint": "{{y}}年の月別予測をUSDで入力します。月を空欄にすると消去されます。",
  "fcBad": "予測はUSDの金額で入力してください。",
  "fcBy": "{{y}}年の予測の最終保存：{{by}}、{{at}}。",
  "yoyCompare": "前年比較",
  "yoyComparison": "YoY比較（月別成長率）",
  "matrixTitle": "年・月別のEXF売上（USD）",
  "matrixNote": "成長率＝その年の合計が前年合計に占める割合（Sales Report by Yearと同じ）。最下行：{{a}}に対する{{b}}の割合を月ごとに表示。その合計は1月〜{{to}}です。",
  "maxLossCard": "YoY最大減少",
  "maxGainCard": "YoY最大増加",
  "growthByMonth": "月別成長率（{{a}}に対する{{b}}）",
  "salesLegend": "売上",
  "growthAmount": "成長額",
  "growthRate": "成長率",
  "unitShare": "数量比（%）",
  "saleAmount": "売上金額",
  "dbByYear": "年別の売上金額と販売数量",
  "dbUnitsCategory": "製品カテゴリ別の販売数量",
  "dbUnitsModel": "モデル別の販売数量（上位15）",
  "dbUnitsBuyer": "バイヤー別の販売数量（上位15）",
  "dbUnitsCountry": "国別の販売数量（上位15）・主力モデル",
  "dbShareCountry": "国別の数量構成比",
  "top15Total": "上位15合計",
  "keyModel": "主力モデル（国内比%）",
  "others": "その他",
  "tabDash": "ダッシュボード",
  "filters": "フィルター",
  "allMonths": "全月",
  "all": "すべて",
  "category": "カテゴリ",
  "product": "製品",
  "kSales": "総売上（USD）",
  "kLines": "注文明細{{n}}件",
  "kUnits": "販売数量",
  "kAvgUnit": "平均{{v}}／個",
  "kBuyers": "バイヤー",
  "kOfYear": "今年は{{n}}社中",
  "kCountries": "販売先の国",
  "kAvgBuyer": "バイヤー平均売上",
  "kProducts": "販売製品{{n}}点",
  "kYoy": "前年比成長率",
  "kVsMonth": "{{y}}年{{m}}との比較：{{v}}",
  "kVsYtd": "{{y}}年1月〜{{m}}との比較：{{v}}",
  "dbByMonth": "{{y}}年の月別売上金額（USD）",
  "avgUnit": "平均／個",
  "ofYear": "年間比（%）",
  "dbTopBuyers": "上位バイヤー（USD）",
  "dbTopProducts": "数量上位の製品",
  "dbByCategory": "カテゴリ別",
  "dbByCountry": "国別",
  "share": "構成比",
  "dbSrcFile": "Miaさんのデータシートから明細単位で取得（2026年9月まで）。",
  "dbSrcSap": "SAP請求データから明細単位で取得（無償品を除く）。",
  "dbSrcBoth": "明細単位：2026年9月まではMiaさんのデータシート、以降はSAP請求データ（無償品を除く）。",
  "tabBuyer": "バイヤー・国別",
  "tabYoy": "前年比",
  "soFar": "{{m}}は進行中のため、これまでの日数分です。同条件の合計は前月までとなります。",
  "yearA": "比較対象",
  "yearB": "と",
  "ytdTitle": "1月〜{{to}}（同条件）",
  "vsYear": "{{y}}との比較：{{v}}",
  "fullYear": "{{y}}年",
  "toMonth": "{{m}}まで",
  "wholeYear": "通年",
  "byMonthTitle": "{{a}}と{{b}}の月別比較（USD）",
  "month": "月",
  "diff": "差異",
  "growth": "成長率",
  "ytdShort": "1月〜{{to}}",
  "yearWise": "年別売上（USD）",
  "maxGain": "最大増加",
  "maxLoss": "最大減少",
  "partialNote": "この表では、進行中の年は前年の通年と比較しています。同条件の数値は上のものです。最大増加／最大減少は通年のみが対象です。",
  "nav": "Overseas Sales",
  "title": "Overseas Sales",
  "sub": "HINCの海外請求（販売組織1100）をUSDで、バイヤー・月別に集計。Sales Team 1の「Sales amount per Year per country」に相当します。",
  "year": "年",
  "groupBy": "グループ化",
  "buyer": "バイヤー",
  "country": "国",
  "search": "検索",
  "searchPh": "バイヤー、国、地域",
  "hideEmpty": "売上のないバイヤーを非表示",
  "excel": "Excel",
  "monthToRead": "SAPから取得する月",
  "readSap": "SAPから取得",
  "reading": "SAPを読み込み中…",
  "confirmReplace": "{{m}}にはワークブックの数値が入っています。代わりにSAPから取得しますか？以後、その月はSAPの請求データが表示されます。",
  "loaded": "{{m}}をSAPから取得しました：請求伝票{{n}}件、USD {{usd}}。",
  "legend": "SAPと表示された月はSAP請求データに基づきます（数値をクリックすると伝票を確認できます）。それ以外はワークブックの数値です。前月分は毎月6日に自動で取得されます。",
  "fromSapAt": "SAPより：{{by}}が{{at}}に取得、伝票{{n}}件",
  "fromFile": "ワークブックより",
  "total": "合計",
  "nBuyers": "バイヤー{{n}}社",
  "noRows": "表示するものがありません。",
  "loading": "読み込み中…",
  "notMapped": "レポートにまだないSAP顧客：{{n}}件",
  "notMappedSub": "SAPから取得した月に請求されていますが、レポートのどの行にも属していません。各顧客をバイヤーに割り当てるか、バイヤーを追加するか、対象外にしてください。それまで、その金額は上の合計に含まれません。",
  "sapCustomer": "SAP顧客",
  "putOn": "割り当て先",
  "pick": "選択…",
  "newBuyer": "＋新規バイヤー",
  "exclude": "レポートの対象外にする",
  "save": "保存",
  "askEditor": "編集権限のある方が割り当てます。",
  "billing": "請求伝票",
  "date": "日付",
  "channel": "チャネル",
  "amountDoc": "金額",
  "rate": "USDレート",
  "close": "閉じる",
  "cancel": "キャンセル",
  "fModel": "モデル",
  "fColor": "カラー",
  "dbModelGrid": "国別・年別の販売数量：{{m}}",
  "dbModelGridSub": "上記フィルターの条件で、売上明細の全年を表示します（年フィルターは下のセクション用です）。数値にカーソルを合わせると売上金額が表示されます。",
  "dbModelGridMonth": "上記フィルターの条件で、各年の{{m}}のみを表示します（月フィルター）。数値にカーソルを合わせると売上金額が表示されます。",
  "dbModelGridNone": "この選択では販売数量がありません。"
};

const dictionary = { ns: 'xSalesBuyer', en, ko, vi, zh, fr, ja };

export default dictionary;
